export const appConfigs = {
    app_name: "Link Energy",
    org_name: process.env.NODE_ENV !== "production" ? "Link Energy (Dev)" : "Link Energy",
    org_url: "https://link-energy.africa",
    api_url: process.env.NODE_ENV !== "production" ? "http://localhost:8866/api/" : (window.location.host === "link-energy.sandbox.co.ke" ? "https://link-energy.sandbox.co.ke:8167/api/" : "https://link-energy.africa:8167/api/"),
    portal_api_url: "https://link-energy.sandbox.co.ke:8167/api/",
    
    auth_key: process.env.NODE_ENV !== "production" ? "XNAgZSnoEsf55nlbmDIJ" : "rK32640byHUTixKE7ge1",
    uploads_url: process.env.NODE_ENV !== "production" ? "http://localhost:8866/u0veDcqIsErQVKXuXeM3/" : (window.location.host === "link-energy.sandbox.co.ke" ? "https://link-energy.sandbox.co.ke:8167/u0veDcqIsErQVKXuXeM3/" : "https://link-energy.africa:8167/u0veDcqIsErQVKXuXeM3/"),
    recaptcha_site_key: "6LfdYeQZAAAAAPijoDtW-p4RLdUZBnc0brmarW5M",
};